<template>
  <div class="row" id="mainBody">
    <div class="col-lg-10 col-md-9 mainPanel">
      <form @submit.prevent="submit()">
        <div class="textEditor form-group">
          <label for="">Naam</label>
          <input
            autocomplete="false"
            v-model="help.name"
            type="text"
            class="form-control"
          />
        </div>
        <div class="textEditor form-group">
          <label for="">Auteur</label>
          <select2 class="" :options="users" v-model="help.user_id" />
        </div>
        <div class="textEditor form-group">
          <label for="">Verstuur</label>
          <input type="number" class="form-control" v-model="help.version" />
        </div>
        <div class="textEditor form-group">
          <label for="">Permission</label>
          <select2-multiple-control
            :options="permissions"
            v-model="help.permission"
            placeholder="Choose users or enter a valid emailaddresses"
          />
        </div>
        <div class="textEditor form-group">
          <label for="">Pagina</label>
          <input
            autocomplete="false"
            v-model="help.path"
            type="text"
            class="form-control"
          />
        </div>
        <div class="textEditor mb-3">
          <div class="content-title-wrap">
            <label for="">Content</label>
            <button class="content-btn-wrap" v-if="contentShow">
              <i class="fa fa-plus" @click="showContent()"></i>
            </button>
          </div>
          <div
            class="help-cont-wrap "
            v-if="!contentShow"
            id="multiCollapseExample2"
            ref="helpCollapse"
          >
            <div class="help-inner-wrap">
              <div class="content-title-wrap">
                <label for="">Add Content</label>
                <button
                  class="content-btn-wrap no-border"
                  type="button"
                  data-toggle="collapse"
                  data-target="#multiCollapseExample2"
                  @click="hideContent()"
                >
                  <i class="fa fa-times"></i>
                </button>
              </div>
              <form @submit.prevent="saveContent()">
                <div class="help-inp-wrap">
                  <label for="">Title</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="content.title"
                  />
                </div>
                <div class="help-inp-wrap">
                  <label for="">Image</label>
                  <input
                    type="file"
                    multiple
                    class="form-control"
                    ref="contentImages"
                    accept="image/png, image/gif, image/jpeg"
                    @change="images()"
                  />
                  <div class="content-image-wrap">
                    <ul class="content-image-ul">
                      <li
                        class="content-image-li"
                        v-for="(img, index) in content.images"
                        :key="index"
                      >
                        <small>{{ img.file.name }}</small>
                        <a @click="removeImg(img.id)" href="javascript:void(0)">
                          <i class="fa fa-times"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="help-inp-wrap">
                  <label for="">File</label>
                  <input
                    type="file"
                    multiple
                    class="form-control"
                    ref="contentFiles"
                    @change="files()"
                  />
                  <div class="content-image-wrap">
                    <ul class="content-image-ul">
                      <li
                        class="content-image-li"
                        v-for="(file, index) in content.files"
                        :key="index"
                      >
                        <small>{{ file.file.name }}</small>
                        <a
                          @click="removeFile(file.id)"
                          href="javascript:void(0)"
                        >
                          <i class="fa fa-times"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="help-inp-wrap">
                  <label for="">Content</label>
                  <editor
                    :init="{
                      height: 300,
                      menubar: false,
                      language: 'nl',
                      plugins: [
                        'advlist autolink lists link image charmap print preview anchor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table paste code help wordcount',
                      ],
                      toolbar:
                        'undo redo | formatselect | bold italic backcolor | \
                                        alignleft aligncenter alignright alignjustify | \
                                        bullist numlist outdent indent | link code | paste | fullscreen | removeformat | help',
                    }"
                    v-model="content.content"
                  />
                </div>
                <div class="help-content-btn">
                  <button class="btn btn-success">
                    <i class="fa fa-save"></i> Save
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div class="help-content-container">
            <div
              class="help-content-cont2"
              v-for="(content, index) in help.content"
              :key="index"
            >
              <div class="d-flex content-arr-cont">
                <h6 class="cont-h6">{{ content.title }}</h6>
                <div class="content-arr-wrap">
                  <button
                    v-if="index != 0"
                    class="content-btn-wrap no-border"
                    type="button"
                    data-toggle="collapse"
                    data-target="#multiCollapseExample2"
                    @click="swap(index, 'up')"
                  >
                    <i class="fa fa-chevron-up"></i>
                  </button>
                  <button
                    v-if="index != help.content.length - 1"
                    class="content-btn-wrap no-border"
                    type="button"
                    data-toggle="collapse"
                    data-target="#multiCollapseExample2"
                    @click="swap(index, 'down')"
                  >
                    <i class="fa fa-chevron-down"></i>
                  </button>
                </div>
              </div>
              <div class="help-img2-cont">
                <p class="cont2-p">Images</p>
                <div class="content-image-wrap">
                  <ul class="content-image-ul">
                    <li
                      class="content-image-li"
                      v-for="(img, index) in help.images[index]"
                      :key="index"
                    >
                      <!-- <small>{{ img.file.name }}</small> -->
                      <img :src="img" class="w-100" alt="" />
                    </li>
                  </ul>
                </div>
              </div>
              <div class="help-img2-cont">
                <p class="cont2-p">File</p>
                <div class="content-image-wrap">
                  <ul class="content-image-ul mt-0 content-img-ul2">
                    <li
                      class="content-image-li"
                      v-for="(file, index) in help.files[index]"
                      :key="index"
                    >
                      <!-- <small>{{ file.file.name }}</small> -->
                      <a :href="file" target="_blank" class="btn btn-success">
                        File {{ ++index }}</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <div class="help-img2-cont">
                <p class="cont2-p">Content</p>
                <p class="cont-txt-p" v-html="content.content"></p>
              </div>
            </div>
          </div>
        </div>
        <div class="textEditor form-group">
          <label for="core">Core</label>
          <input
            type="checkbox"
            v-model="help.core"
            id="core"
            class="help-core"
          />
        </div>
        <!-- <div v-if="message.length > 0" class="alert alert-success">
                <p>
                {{ message }}
                </p>
            </div> -->
        <button class="btn btn-success">
          <i class="fa fa-save"></i> Opslaan
        </button>
      </form>
    </div>
    <div class="col-lg-2 col-md-3">
      <button
        data-toggle="modal"
        data-target="#emailPreview"
        class="btn btn-dark text-white"
      >
        <i class="fa fa-eye"></i> Voorbeeld
      </button>
      <div
        class="modal fade"
        id="emailPreview"
        tabindex="-1"
        role="dialog"
        aria-labelledby="emailPreview"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header" style="border-bottom: unset">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <!-- <div class="modal-body" v-if="preview_loading">
              Aan het laden...
            </div>
            <div class="modal-body" v-else v-html="preview_content"></div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select2MultipleControl from "v-select2-multiple-component";
export default {
  components: {
    Select2MultipleControl,
  },
  data() {
    return {
      contentShow: false,
      help: {},
      content: {
        images: [],
        files: [],
        title: "",
        content: "",
      },
      permissions: [],
      users: [],
      contents: [],
    };
  },
  methods: {
    showContent() {
      this.contentShow = false;
    },
    hideContent() {
      this.contentShow = true;
      window.$(".help-cont-wrap").addClass("collapse");
    },
    saveContent() {
      this.content.images = [];
      this.content.files = [];

      this.help.contents.push({ ...this.content });

      this.$refs.helpCollapse.classList.add("collapse");
      this.content = {
        images: [],
        files: [],
        title: "",
        content: "",
      };

      this.contentShow = true;
    },
    images() {
      var imgs = this.$refs.contentImages.files;
      var temp = [];
      Array.from(imgs).forEach((file) => {
        temp.push({
          id: Math.random() * 99999,
          file: file,
        });
      });
      this.content.images = [...this.content.images, ...temp];
      console.log(this.content.images);
    },
    files() {
      var files = this.$refs.contentFiles.files;
      var temp = [];
      Array.from(files).forEach((file) => {
        temp.push({
          id: Math.random() * 99999,
          file: file,
        });
      });
      this.content.files = [...this.content.files, ...temp];
      console.log(this.content.files);
    },
    removeImg(id) {
      this.content.images = this.content.images.filter((img) => img.id != id);
    },
    removeFile(id) {
      this.content.files = this.content.files.filter((file) => file.id != id);
    },
    swap(index, position) {
      var contents = [...this.help.contents];
      var index2 = index;
      if (position == "up") {
        index2 -= 1;
      } else {
        index2 += 1;
      }
      var temp = contents[index];
      contents[index] = contents[index2];
      contents[index2] = temp;

      this.help.contents = contents;
    },
    submit() {
      console.log(this.help);
      this.$store
        .dispatch("post", {
          endpoint: "/api/v1/help-pages/update",
          details: this.help,
        })
        .then((data) => {
          console.log(data.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getHelp() {
      this.$store
        .dispatch("get", "/api/v1/help-pages/update/" + this.$route.params.id)
        .then((data) => {
          console.log(data);
          var temp = data.data.data;
          this.contents = JSON.parse(data.data.data.content);
          this.help = data.data.data;
          var contents = [];
          var permission = [];
          for (let [key, value] of Object.entries(temp)) {
            if (key == "content") {
              contents = JSON.parse(value);
              console.log(contents);
            }
            if (key == "permission") {
              permission = JSON.parse(value);
            }
          }
          this.help.content = contents;
          this.help.permission = permission;
          console.log(this.help);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getUsers() {
      this.$store
        .dispatch("get", "/api/v1/users/all")
        .then((data) => {
          var temp = data.data.data;
          var users = temp.map((user) => {
            return {
              id: user.id,
              text: user.display_name,
            };
          });

          this.users = [...users];
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getPermissions() {
      this.$store
        .dispatch("get", "/api/v1/permissions")
        .then((data) => {
          var temp = data.data;
          var permissions = temp.map((permission) => {
            return {
              id: permission.id,
              text: permission.name,
            };
          });
          this.permissions = [...permissions];
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  created() {
    this.getUsers();
    this.getPermissions();
    this.getHelp();
  },
};
</script>

<style lang="css" scoped>
.modal-body table {
  width: 100% !important;
}
</style>
